<app-selector
  #selector
  [multiple]="true"
  [type]="type"
  [(ngModel)]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [styles]="styles"
  [displayWithFn]="displayWithFn.bind(this)"
  [optionsFn]="optionsFn.bind(this)"
  [tooltip]="tooltip"
  newItemLabel="Create new area"
  (newItemClick)="on_add_action()"

>
</app-selector>